import { z } from 'zod'
import type { Ref } from 'vue'
import { notEmptyString } from '@/contexts/shared/form-validation/FormValidationRules.helpers'

export const emailSchema = () => notEmptyString

export const passwordSchema = () => z.string()

export const authenticationCodeSchema = (step: Ref<number>) =>
  z.string().superRefine((value, ctx) => {
    if (step.value !== 3) {
      return
    }
    if (!/^\d{6}$/.test(value)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        params: { i18n: 'zod.errors.invalid_auth_code' },
      })
    }
  })
